module.exports = __webpack_public_path__ + "img/vehicle-registration.f869964b.svg";